module.exports = __webpack_public_path__ + "832c7e5fb3a1128972b34ec7b28bfa80.pdf";